import { Injectable } from '@angular/core';
declare let gtag: Function;
declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class GaService {

  public emitEvent(eventAction: string,screenName: string) {
      gtag('event', eventAction, {
        'app_name': 'FINSNELGAME26',
        'screen_name': screenName
      });
    //fbq('track', 'event', { eventCategory: eventCategory, eventLabel: eventLabel== null ? eventAction : eventLabel });
  }
}
